import ICC_PRODUCT_STATUS_TYPES from '../../enums/icc/iccProductStatusTypes';
import {updateMuleSoftConsumerProductData} from '../../state/ducks/consumer';
import {selectIotDeviceData} from '../../state/selectors/iotDevice';
import {dispatch, getState} from '../../state/store';
import productHelpers from '../product/productHelpers';
import {assetMapping} from './iccMarketMappings';

export const consumerAssetsMapping = (data) => {
    const rawMappedConsumerAssets = data['response-data'].data.map((consumerAsset) =>
        consumerAssetMapping(consumerAsset)
    );

    dispatch(updateMuleSoftConsumerProductData(rawMappedConsumerAssets));

    const iotDevice = selectIotDeviceData(getState());
    const {device, holder} = iotDevice || {};
    const {deviceSerialNumber: chargerSerialNumber} = device || {};
    const {deviceSerialNumber: holderSerialNumber} = holder || {};

    const currentChargerConsumerAsset = rawMappedConsumerAssets.find(
        (rawMappedConsumerAssets) => rawMappedConsumerAssets.deviceSerialNumber === chargerSerialNumber
    );
    const currentHolderConsumerAsset = rawMappedConsumerAssets.find(
        (rawMappedConsumerAssets) => rawMappedConsumerAssets.deviceSerialNumber === holderSerialNumber
    );

    const mergedCharger = currentChargerConsumerAsset && {
        ...device,
        ...currentChargerConsumerAsset,
        status: ICC_PRODUCT_STATUS_TYPES.REGISTERED,
    };
    const mergedHolder =
        // If holder connected
        holderSerialNumber &&
        (currentHolderConsumerAsset
            ? {
                  ...holder,
                  ...currentHolderConsumerAsset,
                  status: ICC_PRODUCT_STATUS_TYPES.REGISTERED,
              }
            : {
                  ...holder,
                  status: ICC_PRODUCT_STATUS_TYPES.UNREGISTERED,
              });

    const mappedConsumerAsset = {
        ...iotDevice,
        [mergedCharger && 'device']: mergedCharger,
        [mergedHolder && 'holder']: mergedHolder,
    };

    return (mergedCharger || mergedHolder) && mappedConsumerAsset;
};
export const getMediaId = (material) => {
    try {
        const mediaIdParts = [
            material.materialGroup,
            material.productFamily,
            material.deviceModel,
            material.deviceColor,
        ];
        const mediaName = mediaIdParts.join('_');

        return assetMapping(mediaName);
    } catch (e) {
        return null;
    }
};

const consumerAssetMapping = (data) => {
    const transformedDeviceSerialNumber = productHelpers.getTransformedDeviceSerialNumber(data.internal_id);

    return {
        codentify: data.device_codentify,
        deviceSerialNumber: transformedDeviceSerialNumber,
        deviceColor: data.device_color,
        materialDescription: data.device_material_description,
        materialGroup: data.device_material_group,
        deviceModel: data.device_model,
        deviceProductCode: data.device_product_code,
        deviceVersion: data.device_version,
        packCodentify: data.pack_codentify,
        productFamily: data.product_family,
    };
};
